export default __webpack_public_path__ + "static/media/withdraw.dec81a90.png";